import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ViewIcon } from 'foundations-assets/icons/components/ViewIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SummaryHeaderPreviewThumbnail() {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    padding: "300",
    children: [/*#__PURE__*/_jsx(ViewIcon, {
      size: "300",
      color: "do-not-use-olaf"
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      color: "text-core-on-fill-default",
      typography: "heading-25",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.image.preview"
      })
    })]
  });
}